import React from 'react';
import clsx from 'clsx';
import isNil from 'lodash/isNil';
import ListAltRoundedIcon from '@mui/icons-material/ListAltRounded';
import ForwardToInboxRoundedIcon from '@mui/icons-material/ForwardToInboxRounded';
import SplitActionButton from 'core/components/SplitActionButton';
import useUserInfo from 'pages/Dashboard/hooks/useUserInfo';

export type SendDocumentsActions = {
  onSendOrderForm: () => void;
  onSendReferral: () => void;
  onSendToReferringProvider: () => void;
  referringProviderDisabledReason?: string;
  isSendToReferringProviderDisabled?: boolean;
};

type Props = SendDocumentsActions & {
  disabled?: boolean;
};

export default function VisitNoteDocumentActions({
  disabled,
  onSendOrderForm,
  onSendReferral,
  onSendToReferringProvider,
  referringProviderDisabledReason,
  isSendToReferringProviderDisabled = false,
}: Props) {
  const userInfo = useUserInfo();
  const isFaxEnabled = !isNil(userInfo?.organization?.eFaxConfig);

  return (
    <SplitActionButton
      label="Send External"
      onPrimaryClick={onSendOrderForm}
      items={[
        {
          id: 'send-order-forms',
          label: 'Order Form',
          icon: ListAltRoundedIcon,
          className: 'nw-send-order-forms-button',
          onSelect: onSendOrderForm,
        },
        {
          id: 'send-referral-letter',
          label: 'Referral Form',
          icon: ForwardToInboxRoundedIcon,
          onSelect: onSendReferral,
        },
        ...(isFaxEnabled ? [{
          id: 'send-to-referring-provider',
          label: 'Fax to Referring Provider',
          icon: ForwardToInboxRoundedIcon,
          disabled: Boolean(referringProviderDisabledReason) || isSendToReferringProviderDisabled,
          tooltip: referringProviderDisabledReason,
          onSelect: onSendToReferringProvider,
        }] : []),
      ]}
      variant="outlined"
      disabled={disabled}
      caretDirection="up"
      paperClassName="!min-w-[12rem]"
      placement="top-start"
      classes={{
        primary: clsx('!px-2.5', {
          '!border-blue-500': !disabled,
        }),
        caret: clsx({
          '!border-blue-500': !disabled,
        }),
      }}
    />
  );
}
